import { IBaseState } from "../../index";

export interface IPersonListState extends IBaseState<{}, {}> {
    service?: {};
}

export class PersonListState implements IPersonListState {
    service?: {};
    constructor(options: IPersonListState) {
        this.service = options.service;
    }
}